import {IRange} from "@pg-design/range-module";

import {ROOM_SELECTOR_OPEN_ENDED_VALUE} from "@/components/room_selector/constants/room_selector_options";

import {parseRangeBound} from "./parse_range_bound";

/** Anything that carries rooms bounds: the API body (`null` = unset) or the room selector value (`""` = empty). */
export type RoomsRangeInput = IRange<number | "" | null> | null;

/** "5+" is the last option of the room selector: five rooms or more. */
export const isOpenEndedRoomsBound = (bound: number | undefined) => bound != null && bound >= ROOM_SELECTOR_OPEN_ENDED_VALUE;

/** Bounds to display or to feed the room selector. An open upper bound from the API (`null`) reads as the "5+" option. */
export const getRoomsRangeValues = (rooms: RoomsRangeInput) => {
    const lower = parseRangeBound(rooms?.lower);
    const upper = rooms?.upper === null && lower != null ? ROOM_SELECTOR_OPEN_ENDED_VALUE : parseRangeBound(rooms?.upper);

    return {lower, upper};
};

/** Request body for the API: the "5+" option goes out as an open upper bound, never as the number 5. */
export const getHomeMatchRoomsPatch = (rooms: IRange<number | ""> | null) => {
    const lower = parseRangeBound(rooms?.lower);
    const upper = parseRangeBound(rooms?.upper);

    if (lower == null && upper == null) return null;

    if (isOpenEndedRoomsBound(upper)) return {lower, upper: null};

    return {lower, upper};
};
import {IRange} from "@pg-design/range-module";

import {ROOM_SELECTOR_OPEN_ENDED_VALUE} from "@/components/room_selector/constants/room_selector_options";

import {parseRangeBound} from "./parse_range_bound";

/** Anything that carries rooms bounds: the API body (`null` = unset) or the room selector value (`""` = empty). */
export type RoomsRangeInput = IRange<number | "" | null> | null;

/** "5+" is the last option of the room selector: five rooms or more. */
export const isOpenEndedRoomsBound = (bound: number | undefined) => bound != null && bound >= ROOM_SELECTOR_OPEN_ENDED_VALUE;

/** Bounds to display or to feed the room selector. An open upper bound from the API (`null`) reads as the "5+" option. */
export const getRoomsRangeValues = (rooms: RoomsRangeInput) => {
    const lower = parseRangeBound(rooms?.lower);
    const upper = rooms?.upper === null && lower != null ? ROOM_SELECTOR_OPEN_ENDED_VALUE : parseRangeBound(rooms?.upper);

    return {lower, upper};
};

/** Request body for the API: the "5+" option goes out as an open upper bound, never as the number 5. */
export const getHomeMatchRoomsPatch = (rooms: IRange<number | ""> | null) => {
    const lower = parseRangeBound(rooms?.lower);
    const upper = parseRangeBound(rooms?.upper);

    if (lower == null && upper == null) return null;

    if (isOpenEndedRoomsBound(upper)) return {lower, upper: null};

    return {lower, upper};
};
